export default __webpack_public_path__ + "static/media/fairy.567cd96b.png";